var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 4.0002C2.8 3.5577 3.1575 3.2002 3.6 3.2002H4C4.4425 3.2002 4.8 3.5577 4.8 4.0002V7.2002V8.8002V12.0002C4.8 12.4427 4.4425 12.8002 4 12.8002H3.6C3.1575 12.8002 2.8 12.4427 2.8 12.0002V11.2002H1.6C1.1575 11.2002 0.8 10.8427 0.8 10.4002V8.8002C0.3575 8.8002 0 8.4427 0 8.0002C0 7.5577 0.3575 7.2002 0.8 7.2002V5.6002C0.8 5.1577 1.1575 4.8002 1.6 4.8002H2.8V4.0002ZM13.2 4.0002V4.8002H14.4C14.8425 4.8002 15.2 5.1577 15.2 5.6002V7.2002C15.6425 7.2002 16 7.5577 16 8.0002C16 8.4427 15.6425 8.8002 15.2 8.8002V10.4002C15.2 10.8427 14.8425 11.2002 14.4 11.2002H13.2V12.0002C13.2 12.4427 12.8425 12.8002 12.4 12.8002H12C11.5575 12.8002 11.2 12.4427 11.2 12.0002V8.8002V7.2002V4.0002C11.2 3.5577 11.5575 3.2002 12 3.2002H12.4C12.8425 3.2002 13.2 3.5577 13.2 4.0002ZM10.4 7.2002V8.8002H5.6V7.2002H10.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.8f8bf0376a99349921d9f1748d206c46.svg";
export { ForwardRef as ReactComponent };